<template>
  <main>
    <ul>
      <li><span>收件人：</span><input v-model="submit.addressee" type="text"></li>
      <li><span>联系电话：</span><input v-model="submit.phone" type="tel" maxlength="11"></li>
      <li><span>公司名称：</span><input v-model="submit.company_name" type="text"></li>
      <li><span>邮政编码：</span><input v-model="submit.postal_code" type="text"></li>
      <li @click="selectAddress"><span>选择地址：</span><b class="address"><span>{{ submit.addrObj.text || '请选择' }}</span><i class="icon-you"></i></b></li>
      <li><span>街道地址</span><input v-model="submit.address" type="text"></li>
      <li><span>默认地址：</span><b class="switch" @click="submit.is_default = !submit.is_default" :class="{on: submit.is_default}"></b></li>
    </ul>
    <button @click="save">保存地址</button>
    <addr ref="address" @change="changeAddress"></addr>
  </main>
</template>

<script>
import addr from '@components/address';
import $address from '@api/address';
export default {
  components: {
    addr
  },
  data () {
    return {
      submit: {
        addressee: null,
        company_name: null,
        is_default: false,
        phone: null,
        postal_code: null,
        address: null,
        addrObj: {}
      }
    }
  },
  computed: {
    address () {
      return this.$refs.address;
    }
  },
  created () {
    const { info = {} } = this.$route.params;
    info && this.setDetail(info);
  },
  methods: {
    setDetail (info) {
      const {
        addressee, company_name, is_default, phone, postal_code, address,
        province,
        city,
        district
      } = info;
      this.submit = {
        addressee, company_name, phone, postal_code, address,
        is_default: is_default === 1,
        addrObj: {
          list: [{ name: province }, { name: city }, { name: district }],
          text: province+city+district
        }
      }
    },
    selectAddress () {
      this.address.toggle();
    },
    changeAddress (data) {
      this.submit = { ...this.submit, addrObj: data };
    },
    async save () {
      const data = this.getSaveData();
      const { OK } = await this.sendData(data);
      this.$toast(OK ? '保存成功' : '保存失败');
      OK && this.$router.back();
    },
    sendData (data) {
      const { id } = data;
      return id ? $address.change(id, data, 'PUT') : $address.add(data);
    },
    getSaveData () {
      // 基础参数
      const { addressee, company_name, is_default, phone, postal_code, address, addrObj } = this.submit;
      const [{ name: province }, { name: city }, { name: district }] = addrObj.list;
      const { info = {} } = this.$route.params;
      let data = {
        ...info,
        addressee, company_name, phone, postal_code, address,
        province, city, district,
        is_default: is_default ? 1 : 0,
      }
      return data;
    }
  }
}
</script>

<style scoped src="./addressSet.css"></style>